/* eslint-disable react-hooks/exhaustive-deps */
import MainMenu from '../MainMenu';
import { DevToolsContext } from '../context/context';
import useDevTools from '../hooks/useDevTools';
import useDevToolsContext from '../hooks/useDevToolsContext';
import modules from '../modules';
import styles from './Window.module.scss';
import closeSvg from './assets/close.svg';
import moveSvg from './assets/move.svg';
import resizeSvg from './assets/resize.svg';
import Move from './helpers/Move';
import Resize from './helpers/Resize';
import React, { useLayoutEffect, useRef, useState } from 'react';

const WindowContent = ({ uuid, onClose, reOrder, zIndex }) => {
  const { menu } = useDevTools();

  const positionRef = useRef([10, 40 + 20 * uuid]);
  const sizesRef = useRef([Math.min(window.innerWidth - 60, 900), window.innerHeight * 0.5]);
  const moveRef = useRef();
  const resizeRef = useRef();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [timestamp, setTimestamp] = useState(Date.now());

  useLayoutEffect(() => {
    new Move(uuid, moveRef.current, sizesRef, positionRef, setTimestamp, reOrder);
    new Resize(uuid, resizeRef.current, sizesRef, positionRef, setTimestamp, reOrder);
  }, []);

  return (
    <div
      className={styles.app}
      style={{
        bottom: positionRef.current[1],
        left: positionRef.current[0],
        width: sizesRef.current[0],
        height: sizesRef.current[1],
        zIndex: 9999 + zIndex,
      }}
    >
      <div className={styles.content}>
        <div className={styles.columns}>
          {menu.map(({ id, payload }, index) => {
            const Component = modules[id];

            return (
              <div
                key={id}
                className={styles.column}
                style={{
                  width: `${100 - 10 * index}%`,
                  zIndex: index,
                }}
              >
                <Component payload={payload} />
              </div>
            );
          })}
        </div>
      </div>

      <MainMenu />

      <div className={styles.close} onClick={onClose}>
        <img src={closeSvg} alt="Close" />{' '}
      </div>

      <div
        className={styles.buttons}
        onClick={() => {
          reOrder(uuid);
        }}
      >
        <div className={styles.button} ref={moveRef}>
          <img src={moveSvg} alt="Move" />
        </div>

        <div className={styles.button} ref={resizeRef}>
          <img src={resizeSvg} alt="Resize" />
        </div>
      </div>
    </div>
  );
};

const Window = (props) => {
  const context = useDevToolsContext();

  return (
    <DevToolsContext.Provider value={context}>
      <WindowContent {...props} />
    </DevToolsContext.Provider>
  );
};

export default Window;
